import { create } from "zustand";

interface HoveredItemState {
  hoveredItemId: string | null;
  setHoveredItemId: (id: string | null) => void;
}

/**
 * The POI currently under the cursor, shared between the map and the result list
 * so hovering either one highlights the other.
 *
 * Store rather than URL state: this changes on every pointer move and means
 * nothing in a shared link.
 */
export const useHoveredItemId = create<HoveredItemState>()((set) => ({
  hoveredItemId: null,
  setHoveredItemId: (id) => set({ hoveredItemId: id }),
}));
